import utils from '@/utils/utils'
import secret from '@/utils/secret'

const orderKey = 'cabp_orpro'
const orderNum = 'cabp_ornum'
const notLgCar = 'cabp_nolgcar'
const returnUrl = 'cabp_returnurl'

/** 设置商品信息 */
export function setLocalOrderProsData (content) {
  localStorage.setItem(orderKey, secret.encryptionText(JSON.stringify(content)))
}

export function getLocalOrderProsData () {
  return secret.decryptText(localStorage.getItem(orderKey))
}

export function removeLocalOrderProsData () {
  localStorage.removeItem(orderKey)
}

/** 设置订单号 */
export function setLocalOrderNumData (content) {
  sessionStorage.setItem(orderNum, secret.encryptionText(content))
}

export function getLocalOrderNumData () {
  return secret.decryptText(sessionStorage.getItem(orderNum))
}

export function removeLocalOrderNumData () {
  sessionStorage.removeItem(orderNum)
}

/** 设置购物车（未登录） */
export function setLocalNotLgCarData (content) {
  sessionStorage.setItem(notLgCar, secret.encryptionText(JSON.stringify(content)))
}
export function getLocalNotLgCarData () {
  let localCar = sessionStorage.getItem(notLgCar)
  if (utils.isNotEmpty(localCar)) {
    return JSON.parse(secret.decryptText(localCar))
  } else {
    return null
  }
}
export function removeLocalNotLgCarData () {
  sessionStorage.removeItem(notLgCar)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js